import { Axios } from 'utils/AxiosConfig'

export const postRequestOTPLogin = async (payload) => {
  const { data: response } = await Axios.post(`get-otp-login`, payload)
  return response
}
export const postResendReqOTPLogin = async (payload) => {
  const { data: response } = await Axios.post(`resend-otp-login`, payload)
  return response
}
export const postLogin = async (payload) => {
  const { data: response } = await Axios.post(`login`, payload)
  return response
}
